/* ChicChac — announcement bar as a SEAMLESS infinite marquee.
   Horizon ships the announcement bar as a fade slideshow (one message at a
   time). This converts it into a continuously scrolling marquee with NO gap:
   the message group is repeated enough times to overfill the viewport, then
   the whole strip is duplicated so translateX(-50%) loops back to an identical
   frame — no "list ends, jump, restart". Constant speed regardless of width. */
(function () {
  'use strict';
  var SPEED = 70; // px per second

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  function build() {
    var slidesWrap = document.querySelector('.announcement-bar__slides');
    if (!slidesWrap || slidesWrap.__ccMarq) return;
    var comp = slidesWrap.closest('announcement-bar-component');
    var slides = Array.prototype.slice.call(slidesWrap.querySelectorAll('.announcement-bar__slide'));
    var items = slides.map(function (s) { return s.innerHTML; });
    if (!items.length) return;

    slidesWrap.__ccMarq = true;
    if (comp) comp.removeAttribute('autoplay');
    var arrows = comp && comp.querySelector('slideshow-arrows');
    if (arrows) arrows.style.display = 'none';

    var SEP = '<span class="cc-marq__sep" aria-hidden="true">&#9670;</span>';
    var unit = items.map(function (h) { return '<span class="cc-marq__item">' + h + '</span>'; }).join(SEP) + SEP;

    slidesWrap.innerHTML = '';
    slidesWrap.classList.add('cc-marq');
    var track = document.createElement('div');
    track.className = 'cc-marq__track';
    slidesWrap.appendChild(track);

    function groupHtml() { return '<div class="cc-marq__group">' + unit + '</div>'; }

    function layout() {
      // measure one group
      track.style.animation = 'none';
      track.innerHTML = groupHtml();
      var groupW = track.firstChild.getBoundingClientRect().width || 1;
      var vw = slidesWrap.getBoundingClientRect().width || window.innerWidth || 1;

      // repeat the group until one "half" comfortably exceeds the viewport,
      // so there is always content filling the screen during the scroll
      var reps = Math.max(1, Math.ceil(vw / groupW) + 1);
      var half = '';
      for (var i = 0; i < reps; i++) half += groupHtml();
      track.innerHTML = half + half;   // two identical halves → -50% loops seamlessly

      var halfW = track.getBoundingClientRect().width / 2;
      track.style.animation = '';                       // restore CSS animation
      track.style.animationDuration = (halfW / SPEED) + 's';
    }

    layout();
    window.addEventListener('resize', debounce(layout, 250));
  }

  if (document.readyState !== 'loading') build();
  else document.addEventListener('DOMContentLoaded', build);
  setTimeout(build, 700);
})();
